import type { PLACubeViewSettings } from "./PLACubeTimeView";

const settingsKey = (projectId: string) => `PLAState-globalCubeView-${projectId}`;

export function readPLACubeViewSettings(storage: Pick<Storage, "getItem">, projectId: string, dimensionId = ""): PLACubeViewSettings {
   const saved = storage.getItem(settingsKey(projectId));
   if (!saved) return { dimensionId };
   try {
      const value: unknown = JSON.parse(saved);
      if (!value || typeof value !== "object") throw new Error("Expected cube view settings object");
      return {
         dimensionId,
         memberId: "memberId" in value && typeof value.memberId === "string" ? value.memberId : undefined,
         latest: "latest" in value && value.latest === true
      };
   } catch (error) {
      console.warn("Failed to restore PLA global cube settings", error);
      return { dimensionId };
   }
}

export function savePLACubeViewSettings(storage: Pick<Storage, "setItem">, projectId: string, settings: PLACubeViewSettings): void {
   storage.setItem(settingsKey(projectId), JSON.stringify({
      memberId: settings.memberId,
      latest: Boolean(settings.latest)
   }));
}
